import { AnyAction } from 'redux';

const isActionOfType = <Action extends AnyAction>(actionType: string) => (action: AnyAction): action is Action =>
  action.type === actionType;

export default isActionOfType;
